module.exports = __webpack_public_path__ + "img/baoxian04.193e351f.png";